<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->
		<!-- <el-button @click="showDialog">打开弹出框</el-button> -->
		<!--    <el-dialog
		         title="提示"
		         :visible.sync="dialogVisible"
		         width="50%"
		         :before-close="handleClose"
		       >
		         <slot>创建成功</slot>
		       </el-dialog> -->

		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar></rosidebar>
				<div style="float: right;width:calc(100% - 269px);overflow: auto;height:1090px;background: white;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						<!-- 您的位置： -->
						<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
						<span style="color:#07ccec;">修改信息</span>
					</h6>
					<el-form :model="new_infor_form" ref="new_infor_form" :rules="rules" label-width="100px"
						class="demo-ruleForm" style="padding-right:20px;">

						<div style="overflow: hidden;">
							<el-form-item label="地址信息" prop="address" style="float: left;width: 100%;">
								<el-cascader style="width: 100%;" size="large" :options="AreaOptions"
									v-model="selectedArea" @change="handleChangeArea">
								</el-cascader>
							</el-form-item>


						</div>
						<div style="overflow: hidden;">
							<el-form-item label="详细地址" prop="address" style="float: right;width: 100%;">
								<el-input v-model="new_infor_form.address"></el-input>
							</el-form-item>
						</div>
						<div style="overflow: hidden;">

							<el-form-item label="邮政编码" prop="postcode" style="float: right;width: 100%;">
								<el-input v-model="new_infor_form.postcode"></el-input>
							</el-form-item>

						</div>
						<div style="overflow: hidden;">
							<el-form-item label="委托人" prop="contact" style="float: left;width: 100%;">
								<el-input v-model="new_infor_form.contact"></el-input>
							</el-form-item>
						</div>
						<div style="overflow: hidden;">
							<el-form-item label="手机" prop="contact_mobile" style="float: left;width: 100%;">
								<el-input v-model="new_infor_form.contact_mobile"></el-input>
							</el-form-item>
						</div>
					</el-form>
					<el-checkbox v-model="checked">设为默认地址</el-checkbox>
					<div style="overflow: hidden;width: 50%;margin:15px auto;">
						<a @click="update_address" style="font-size: 12px;">
							<button class="vs-btn style2"
								style="border-radius: 10px;height:35px;width: 150px;background-color: red;color:white;padding:0;border-radius: 5px;">确认</button>
						</a>
					</div>
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	import {
		provinceAndCityData,
		regionData,
		provinceAndCityDataPlus,
		regionDataPlus,
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
	export default {
		name: 'Demo',
		data() {
			return {
				selectedArea: [],
				AreaOptions: regionData,
				checked: '',
				new_infor_form: {
					'unit_name': '',
					'address': '',
					'postcode': '',
					'contact': '',
					'contact_mobile': '',
					'contact_phone': '',
					'default': '',
					'email': ''
				},
				rules: {
					unit_name: [{
						required: true,
						message: '单位名称不能为空',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '地址不能为空',
						trigger: 'blur'
					}],
					postcode: [{
						required: true,
						message: '邮编不能为空',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					contact_mobile: [{
						required: true,
						message: '手机不能为空',
						trigger: 'blur'
					}],
					contact_phone: [{
						required: false
					}],
					default: [{
						required: false,
					}],
					email: [{
						required: false
					}]
				},

			}
		},
		mounted() {
			// var id = this.$route.query.id
			// // debugger
			// console.log('-----i----')
			// console.log(id)
			this.get_now_select_adddress()
			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {

			handleChangeArea(value) {
				console.log(value)
				const str = CodeToText[value[0]] + '/' + CodeToText[value[1]] + '/' + CodeToText[value[2]]
				console.log(str)
				this.new_infor_form.province = CodeToText[value[0]]
				this.new_infor_form.city = CodeToText[value[1]]
				this.new_infor_form.area = CodeToText[value[2]]

			},
			get_now_select_adddress() {
				// var id = this.id
				// debugger
				var id = this.$route.query.id
				var data = {
					'id': id,
				}
				console.log(data)
				// debugger
				fetchPost('/ro/web_eshop/user/address/detail/v1', data).then(response => {
					console.log(response)
					var now_select_address_info = response.data.detail
					this.checked = now_select_address_info.default
					this.new_infor_form.address = now_select_address_info.address
					this.new_infor_form.postcode = now_select_address_info.postcode
					this.new_infor_form.contact = now_select_address_info.receiver_name
					this.new_infor_form.contact_mobile = now_select_address_info.mobile
					this.id = now_select_address_info.id

					var province = TextToCode[now_select_address_info.province].code
					var city = TextToCode[now_select_address_info.province][now_select_address_info.city].code
					var area = TextToCode[now_select_address_info.province][now_select_address_info.city][
						now_select_address_info.area
					].code
					this.selectedArea = [province, city, area]
					// debugger
					this.new_infor_form.province = now_select_address_info.province
					this.new_infor_form.city = now_select_address_info.city
					this.new_infor_form.area = now_select_address_info.area

				})




			},

			handleClose(done) {
				var self = this
				this.$confirm('确认修改？')
					.then(_ => {
						self.$router.back()
					})
					.catch(_ => {});
			},

			update_address() {
				var id = this.$route.query.id
				var data = {
					'id': id,
					'address': this.new_infor_form.address,
					'postcode': this.new_infor_form.postcode,
					'receiver_name': this.new_infor_form.contact,
					'mobile': this.new_infor_form.contact_mobile,
					'email': this.new_infor_form.email,
					'province': this.new_infor_form.province,
					'city': this.new_infor_form.city,
					'area': this.new_infor_form.area,
					'default': this.checked,

				}
				console.log('update-------')
				console.log(data)
				// debugger
				var self = this
				// self.handleClose()
				this.$refs.new_infor_form.validate(valid => {
					if (valid) {
						fetchPost('/ro/web_eshop/user/address/edit/v1', data).then(response => {
							// self.handleClose()
							self.$message.success('更新成功')
							self.$router.back()

						})
					} else {
						self.$message.error('请完善必填字段')
					}
				})




			}


		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	.ro-register-input-box {
		width: 60%;
		overflow: hidden;
		line-height: 50px;
		margin: auto;
	}

	.ro-register-input-box span {
		font-weight: 800;
	}

	.ro-register-input {
		border-radius: 10px !important;
		height: 50px !important;
		margin-bottom: 15px;
		width: 80%;
		float: left;
	}

	.vs-btn.style3,
	.vs-btn.style2 {
		margin-left: 0;
	}

	.el-form-item__label {
		font-weight: 500;
		color: #333333 !important;
	}
</style>